import secureLocalStorage from "react-secure-storage";
import { Grid, GridColumn as Column, GridDetailRow } from "@progress/kendo-react-grid";
import React from "react";
import * as moment from "moment";

export class ActivitiesDetails extends GridDetailRow {
  approvedCell = (event) => {
    return <td>{event.dataItem.isApproved ? "Yes" : "No"}</td>;
  };
  statusCell = (event) => {
    return <td>{event.dataItem.isClosed ? "Closed" : "Open"}</td>;
  };
  dateCell = (event) => {
    return <td>{event.dataItem[event.field] ? moment(new Date(event.dataItem[event.field])).format("DD-MMM-YYYY") : ""}</td>;
  };
  render() {
    const data = this.props.dataItem.taskActions
      ? this.props.dataItem.taskActions
      : [];
    return (
      <div  className="riskReportMitigation" id="home-riskMitigation" >
       
          <Grid data={data} 
           
           >
            <Column
              field="organizationUnitName"
              title="Workstream"
              width="200px"
            />
            <Column field="taskActionNumber" title="Activity Number" width="200px" />
            <Column
              field="isApproved"
              title="Approved"
              width="200px"
              cell={this.approvedCell}
            />
            <Column
              field="taskActionTitle"
              title="Activity Title"
              width="200px"
            />
            <Column
              field="taskActionDescription"
              title="Activity Description"
              width="200px"
            />
            <Column
              field="cost"
              title={
                "Cost of Activity" +
                " (" +
                secureLocalStorage.getItem("currency") +
                ")"
              }
              width="200px"
            />
            <Column
              field="effort"
              title={"Effort" + " (Days)"}
              filter={"numeric"}
              width="200px"
            />
            <Column
              field="percentageOnTrack"
              title="% on Track"
              width="200px"
              filter={"numeric"}
            />
            <Column
              field="percentageCompletion"
              title="% Completion"
              width="200px"
              filter={"numeric"}
            />
            <Column
              field="priorityRankingName"
              title="Priority Ranking"
              width="200px"
            />

            <Column
              field="originalCompletionDate"
              title="Original Completion Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              cell={this.dateCell}
            />
            <Column
              field="projectedCompletionDate"
              title="Projected Completion Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              cell={this.dateCell}
            />
            <Column
              field="actualCompletionDate"
              title="Actual Completion Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              cell={this.dateCell}
            />
            <Column
              field="proximityAlertDate"
              title="Proximity Alert Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              cell={this.dateCell}
            />
            <Column
              field="delayConsequence"
              title="Delay Consequence"
              width="200px"
            />
            <Column
              field="alertStakeHolders"
              title="Alert Stakeholders"
              width="200px"
            />
            <Column
              field="alertDescription"
              title="Alert Description"
              width="200px"
            />
            <Column field="ownerName" title="Activity Owner" width="200px" />
            <Column
              field="createdDate"
              title="Created Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              cell={this.dateCell}
            />
            <Column field="createdByName" title="Created By" width="200px" />
            <Column
              field="updatedDate"
              title="Updated Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              cell={this.dateCell}
            />
            <Column field="updatedByName" title="Updated By" width="200px" />
            <Column
              field="closedDate"
              title="Closed Date"
              width="200px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              cell={this.dateCell}
            />
            <Column
              field="isClosed"
              title="Status"
              width="200px"
              cell={this.statusCell}
            />

            <Column field="departments" title="Departments" width="150px" />
            <Column
              field="externalStatus"
              title="External Status"
              width="120px"
            />
            <Column field="weeklyReport" title="Weekly Report" width="100px" />
          </Grid>
         
      </div>
    );
  }
}
